module.exports = __webpack_public_path__ + "img/page_bg.9c6f3592.png";